import type { UIMenuSection as UIMenuSectionTypes } from '@creoate/virgo-content-api';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';

import useVirgoContent from 'hooks/useVirgoContent';

import MenuTitle from 'components/Header/TopMenu/components/MenuTitle';
import BackButton from './BackButton';
import TopMenuMobileLink from './TopMenuMobileLink';
import BannersImage from '../components/BannersImage';

import { INavLink } from '../utils/types';

type Props = { selectedNavLinkItem: INavLink; handleBack: () => void; handleCategoryClick: (data: string) => void };

const UIMenuSection = ({ selectedNavLinkItem, handleBack, handleCategoryClick }: Props) => {
  const { topMenu } = useVirgoContent();

  const selectedMenu = topMenu?.find(
    (menu, index) => index === selectedNavLinkItem?.index && menu?.component === selectedNavLinkItem?.component
  ) as UIMenuSectionTypes;

  return (
    <>
      <BackButton handleOnClick={handleBack} label={selectedNavLinkItem?.label} />

      <Box sx={{ height: '100%', overflowY: 'auto' }}>
        <Stack sx={{ padding: '0 21px' }}>
          {selectedMenu?.categories?.length > 0 && (
            <>
              <TopMenuMobileLink
                type="title"
                href={selectedMenu?.link?.url}
                label={`Shop All ${selectedNavLinkItem?.label}`}
              />

              {selectedMenu?.categories?.map((category, index) => {
                const hasSubcategories = category?.subcategories?.length > 0;

                return (
                  <TopMenuMobileLink
                    label={category?.name}
                    showRightIcon={hasSubcategories}
                    key={`ui.menu-section-${selectedMenu?.label}-category-${index + 1}`}
                    {...(!hasSubcategories
                      ? { href: `/product-category/${category?.slug}` }
                      : { handleOnClick: () => handleCategoryClick(category?.name) })}
                  />
                );
              })}
            </>
          )}
        </Stack>

        <Divider />

        <Stack sx={{ padding: '0 21px' }}>
          {selectedMenu?.wholesalers?.length > 0 && (
            <>
              <MenuTitle title="Featured Brands" />

              {selectedMenu?.wholesalers?.map((wholesaler, index) => (
                <TopMenuMobileLink
                  label={wholesaler?.brandName}
                  href={`/store/${wholesaler?.slug}`}
                  key={`ui.menu-section-${selectedNavLinkItem?.index}-wholesaler-${index + 1}`}
                />
              ))}
            </>
          )}
        </Stack>

        <Divider />

        <Stack sx={{ padding: '0 21px' }}>
          {selectedMenu?.banners?.map((banner, index) => (
            <BannersImage
              href={banner?.link?.url}
              src={banner?.image?.url}
              alt={banner?.link?.label}
              key={`ui.menu-section-${selectedNavLinkItem?.index}-banner-${index + 1}`}
            />
          ))}
        </Stack>
      </Box>
    </>
  );
};

export default UIMenuSection;
